import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { Grid, IconButton, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { GUIDE_TYPE } from 'yeself-common/ModelConstant';

import { MOMENT_DATETIME_FORMAT_DISPLAY_SECONDS } from 'Console/constants/date';

const styles = (theme) => ({
    guideName: {
        marginRight: 10,
    },
    guideUrl: {
        fontSize: theme.typography.pxToRem(12),
        letterSpacing: '0.0357143em',
        paddingTop: theme.typography.pxToRem(8),
    },
    guideMessageWithoutExpansionBtn: {
        fontSize: theme.typography.pxToRem(12),
        letterSpacing: '0.0357143em',
        whiteSpace: 'pre-line',
        paddingBottom: theme.typography.pxToRem(12),
        paddingTop: theme.typography.pxToRem(12),
    },
    tableIconExpanded: {
        transform: 'rotate(180deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.longest,
        }),
    },
    tableIconCollapsed: {
        transform: 'rotate(0deg)',
    },
});

const GuideListItemContent = ({ classes, guide, guideLanguage, showGuideDetail, toggleTable }) => (
    <>
        <Grid container direction="column">
            <Grid container item direction="row" alignItems="center">
                <Typography className={classes.guideName} variant="h6">
                    {guide.name[guideLanguage] || guide.name.en}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    {`(${moment(guide.createdDate, 'x').format(
                        MOMENT_DATETIME_FORMAT_DISPLAY_SECONDS
                    )})`}
                </Typography>
            </Grid>
            <Grid container justify="space-between" alignItems="flex-end">
                <Typography
                    className={classes.guideUrl}
                    style={
                        guide.description && guide.description[guideLanguage]
                            ? { paddingBottom: 0 }
                            : { paddingBottom: 12 }
                    }
                >
                    {guide.initialUrl}
                </Typography>
                {!guide.description ||
                    (!guide.description[guideLanguage] && guide.type !== GUIDE_TYPE.RECORDING && (
                        <IconButton onClick={() => toggleTable()}>
                            <ExpandMoreIcon
                                className={
                                    showGuideDetail
                                        ? classes.tableIconExpanded
                                        : classes.tableIconCollapsed
                                }
                            />
                        </IconButton>
                    ))}
            </Grid>
        </Grid>
        {guide.description && guide.description[guideLanguage] && (
            <Grid container direction="row" alignItems="center" justify="space-between">
                <Typography
                    className={
                        guide.type === GUIDE_TYPE.RECORDING
                            ? classes.guideMessageWithoutExpansionBtn
                            : classes.guideMessage
                    }
                >
                    {guide.description[guideLanguage] || guide.description.en}
                </Typography>
                {guide.type !== GUIDE_TYPE.RECORDING && (
                    <IconButton onClick={() => toggleTable()}>
                        <ExpandMoreIcon
                            className={
                                showGuideDetail ? classes.tableIconExpanded : classes.tableIconCollapsed
                            }
                        />
                    </IconButton>
                )}
            </Grid>
        )}
    </>
);

export default withStyles(styles)(GuideListItemContent);
